import { ThankYou } from "@/pages/donor-profile/sections/profile/thankYou";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/thankYou")({
  component: ThankYou,
});
